<template>
  <div class="switch-container">
    <label class="switch-label" for="switch">{{ label }}</label>
    <label class="switch">
      <input type="checkbox" :checked="modelValue" @click="toggleSwitch($event)" />
      <span class="slider round"></span>
    </label>
  </div>
</template>
  
<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Toggle Switch',
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleSwitch(event) {
      const newValue = event.target.checked;
      console.log("Updating switch value:" + newValue);
      this.$emit('update:modelValue', newValue); // Emit for v-model
      this.$emit('onClick', newValue); // Emit custom event if needed
    },
  },
};
</script>
  
<style>
.switch-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* Styles for switch button */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196F3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.switch-label {
  display: inline-block;
  margin-left: 0.5rem;
  font-size: 1rem;
  line-height: 34px;
}

.switch-label:first-child {
  margin-left: 0;
  margin-right: 0.5rem;
}
</style>
  